import { z } from "zod";
export const ComponentMapEntry = z.object({
    id: z.string().uuid(),
    source: z.string(),
    componentName: z.string(),
    createdAt: z.string().datetime(),
});
export const ComponentMapListResponse = z.object({
    entries: z.array(ComponentMapEntry),
});
export const ComponentMapAddRequest = z.object({
    componentName: z.string().min(1).max(200),
    source: z.string().min(1).max(40).default("jira"),
});
export const ComponentMapIdParam = z.object({
    repoId: z.string().uuid(),
    entryId: z.string().uuid(),
});
export const ComponentMapRepoParam = z.object({
    repoId: z.string().uuid(),
});
export const ComponentMapDeleteResponse = z.object({
    deleted: z.literal(true),
});
//# sourceMappingURL=component-map.js.map